module.exports = __webpack_public_path__ + "6b89cf1000192187bbebbda6218290d4.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/mt.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/mt.svg
// module chunks = 0